module.exports = __webpack_public_path__ + "static/media/banner-realtors.4b490a24.jpg";